const permissions = {
    read: '閲覧',
    write: '編集',
    view: '閲覧',
    edit: '編集',
    delete: '削除',
    share: '共有',
    admin: '管理者',
    owner: '所有者',
    public: '公開',
    private: 'プライベート',
    restricted: '制限付き',
    loadFailed: '権限の読み込みに失敗しました',
    saveFailed: '権限の保存に失敗しました',
    deleteFailed: '権限の削除に失敗しました',
    manageDescription: 'このドキュメントにアクセスできるユーザーと実行可能な操作を管理します。',
    addPermission: '権限を追加',
    editPermission: '権限を編集',
    noPermissions: '権限が設定されていません',
    noPermissionsDescription: '「権限を追加」からユーザーにアクセス権を付与できます',
    entity: '対象',
    type: 'タイプ',
    grantedBy: '付与者',
    grantedDate: '付与日',
    entityType: '対象タイプ',
    selectEntity: '{{type}}を選択',
    readDescription: '閲覧 - ドキュメントを表示できます',
    writeDescription: '編集 - ドキュメントを編集できます',
    shareDescription: '共有 - 他のユーザーに共有できます',
    deleteDescription: '削除 - ドキュメントを削除できます',
    types: {
      user: 'ユーザー',
      group: 'グループ',
      tenant: 'テナント',
    },
  };

export default permissions;
